export const login_i18n = {
  // Brand panel on the sign-in screen. Short and concrete: what the
  // product does, not how well it does it.
  panelKicker: "WACheckin · 2026",
  panelCta: "WACheckin entdecken",
  partnersLabel: "Verbunden mit",
  // Cards in the panel scene.
  escena: {
    reservas: "Buchungen",
    mensajes: "Automatische Nachrichten",
    llaves: "Digitale Schlüssel",
    checkin: "Online-Check-in",
    cobros: "Automatische Zahlungen",
    autoridades: "Behörden & Meldepflicht",
  },

  // Step 2: the code that arrives by email.
  verify: {
    title: "Prüfen Sie Ihre E-Mails",
    titleWhatsapp: "Prüfen Sie Ihr WhatsApp",
    sending: "Wird gesendet…",
    destinoWhatsapp: "Wird gesendet an",
    destinoCorreo: "Wird gesendet an",
    intro: "Wir haben einen {largo}-stelligen Code gesendet an",
    submit: "Anmelden",
    submitting: "Wird geprüft...",
    back: "Anderes Konto verwenden",
    resendAsk: "Nicht erhalten?",
    resend: "Code erneut senden",
    resendWait: "Erneut senden in {s}s",
    resendDone: "Wir haben Ihnen einen neuen Code gesendet.",
    expires: "Der Code läuft ab in {tiempo}",
    expired: "Der Code ist abgelaufen. Fordern Sie einen neuen an.",
    digitAria: "Ziffer {n} von {total}",
    otroMetodo: "Keine E-Mail erhalten?",
    porWhatsapp: "Per WhatsApp erhalten",
    preferesCorreo: "Lieber per E-Mail?",
    porCorreo: "Per E-Mail erhalten",
    introWhatsapp: "Wir haben einen {largo}-stelligen Code per WhatsApp gesendet an",
    enviadoWhatsapp: "Wir haben Ihnen den Code per WhatsApp gesendet.",
  },
  langLabel: "Sprache",
  panelTitle: "Alle Ihre Unterkünfte, automatisiert mit KI",
  panelDesc: "Check-in, Nachrichten, Schlüssel, Zahlungen und Behördenmeldung. Ein Panel für alles.",

  bannerAlt: "Login-Hintergrund",
  brandAlt: "WA Checkin",
  footerLogoAlt: "WA Checkin",
  togglePasswordAria: "Passwortanzeige umschalten",

  title: "Willkommen zurück!",
  infoTitle: "Wenn Sie bereits ein Konto haben, melden Sie sich mit Ihrer E-Mail-Adresse an.",
  infoDesc: "Wenn Sie noch kein Konto haben, können Sie sich unten registrieren.",

  emailLabel: "E-Mail",
  emailPlaceholder: "E-Mail-Adresse eingeben",

  passwordLabel: "Passwort",
  passwordPlaceholder: "Passwort eingeben",

  forgot: "Passwort vergessen?",

  submit: "Anmelden",
  submitting: "Anmeldung läuft...",

  noAccount: "Noch kein Konto?",
  signup: "Registrieren",

  terms: "AGB",
  privacy: "Datenschutz",
  copyright: "© 2024–{anio} WA Checkin. Alle Rechte vorbehalten.",

  resetSuccess: "Wir haben Ihnen eine E-Mail zum Zurücksetzen Ihres Passworts gesendet.",

  errors: {
    default: "Anmeldung fehlgeschlagen.",
    network: "Verbindungsfehler. Bitte versuchen Sie es erneut.",
  },
  resetPassword: {
    title: "Passwort zurücksetzen",
    infoTitle: "Wir senden Ihnen einen Link zum Zurücksetzen per E-Mail",
    infoDesc:
      "Geben Sie Ihre E-Mail-Adresse ein und Sie erhalten eine Anleitung zum Zurücksetzen Ihres Passworts.",

    labels: {
      email: "E-Mail-Adresse",
    },

    placeholders: {
      email: "name@email.com",
    },

    hints: {
      email: "Achten Sie darauf, die E-Mail-Adresse einzugeben, mit der Sie sich registriert haben.",
    },

    buttons: {
      send: "Senden",
      sending: "Wird gesendet...",
    },

    successTitle: "Fertig!",
    successDesc: "Prüfen Sie Ihren Posteingang (auch den Spam-Ordner).",

    aria: {
      close: "schließen",
    },

    toasts: {
      emailRequired: "Bitte geben Sie Ihre E-Mail-Adresse ein.",
      sent: "Wir haben eine E-Mail mit der Anleitung gesendet.",
      userNotFound: "Benutzer nicht gefunden.",
      networkError: "Verbindungsfehler. Bitte versuchen Sie es erneut.",
    },
  },

  
  common: {
    ok: "OK",
    cancel: "Schließen",
  },
};
